// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3yfhU","container":"styles_container__3zGhh","title":"styles_title__3Pp8l","wrapper":"styles_wrapper__2ZMnq","answer":"styles_answer__2lLPG"};